/* home page used js */
function simpleCounter(id, target, finalText) {
  const el = document.getElementById(id);
  if (!el) {
    console.error(id + " not found");
    return;
  }

  let count = 0;
  const step = Math.ceil(target / 100);

  const interval = setInterval(() => {
    count += step;
    if (count >= target) {
      el.innerText = finalText;
      clearInterval(interval);
    } else {
      el.innerText = count.toLocaleString();
    }
  }, 30);
}

// Start counters immediately
simpleCounter("customersCount", 80000, "80,000+");
simpleCounter("consultationsCount", 42000, "42K+");
simpleCounter("unitsCount", 250000, "2.5L");